import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appPerfiles]'
})
export class PerfilesDirective {

  constructor( private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {

  }

  ngOnInit(): void {
  }

  @Input() set appPerfiles(perfilId: number) {

    let modules = localStorage.getItem("modulesId").split(",");

    if (modules.includes(perfilId.toString())) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }

  }
}


